import type {Pinia} from 'pinia';
import {callOnce, defineNuxtPlugin, useAuth, useMaltVisitorId} from '#imports';

export default defineNuxtPlugin({
    name: 'fetch-auth',
    dependsOn: ['backend-api-cookies'],
    async setup(nuxtApp) {
        const $pinia = nuxtApp.$pinia as Pinia;
        const authStore = useAuth($pinia);
        const maltVisitorId = useMaltVisitorId();

        await callOnce('current-session', async () => {
            await authStore.checkIfLoggedOrIfNeedingRedirect();

            if (authStore.userVisitorId) {
                maltVisitorId.value = authStore.userVisitorId;
            }
        });
    },
});
